/** Taxas do parcelamento no cartão (% sobre o valor da cobrança). À vista = 1×. */
export const CARD_INSTALLMENT_FEES = [
  { installments: 1, pct: 4.2 },
  { installments: 2, pct: 6.09 },
  { installments: 3, pct: 7.01 },
  { installments: 4, pct: 7.91 },
  { installments: 5, pct: 8.8 },
  { installments: 6, pct: 9.67 },
  { installments: 7, pct: 12.59 },
  { installments: 8, pct: 13.42 },
  { installments: 9, pct: 14.25 },
  { installments: 10, pct: 15.06 },
  { installments: 11, pct: 15.87 },
  { installments: 12, pct: 16.66 },
];

/** Total no cartão = valor base × (1 + taxa). PIX usa só o valor base (0% adicional). */
export function totalWithCardFee(base, pct) {
  return base * (1 + pct / 100);
}
